import { sectionType } from "../../../../sectionType"
import { ColumnDefinition } from "../../models/ColumnDefinition/column-definition"
import { columnType } from "./column-type.enum"
import { segmentType } from "./segment-type";

export enum variantEnum { single = 'single' };
export enum subtypeEnum { single = 'single' };
export enum columnSubtypeEnum { body = 'body' };

export const columnDefs: ColumnDefinition<columnType, subtypeEnum, segmentType, variantEnum, columnSubtypeEnum>[] =
    [
        {
            type: columnType.H_S,
            bays: 1,
            columnSubtypes: [columnSubtypeEnum.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.H_S_R]
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.H_M1M2,
            bays: 3,
            columnSubtypes: [columnSubtypeEnum.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.H_M1M2_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.H_M13M23_R]
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.H_L,
            bays: 2,
            columnSubtypes: [columnSubtypeEnum.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.H_L_R]
                        }],
                    }, {
                        floors: 3,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.H_L3_R]
                        }],
                    }]
                },
            ]
        },
    ];
